import { isObject } from "@pineapplelab/util";
import { Paging } from "../paging";
import { FBase } from "./FBase";
import { IsAlpha, IsAlphanumeric, IsEmail } from "@pineapplelab/validators";
import { Category } from "./category";

export class Clients extends FBase {

  @IsAlpha({ label: 'Name', allowedCharacters: ' ' })
  name: string = null;
  @IsAlphanumeric({label: 'Description', allowedCharacters: '< > /'})
  description: string = null;
  image: string = null;
  category: Category.ICategory = null;
  @IsEmail({ label: 'Email' })
  email: string = null;
  phone: string = null;
  logo: string = null;

  fileName: string;
  fileSize: string;

  __fileThumbnailCover: File;
  __fileCoverImage: File;
  __fileVideo: File;
  __fileImage: File;
  __fileLogoImage: File;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}
export namespace Clients {
  export const PATH = 'clients';

  export const PAGING = new Paging<Clients>(<Paging.IPaging>{
    collection: PATH
  });
}
